import { render, staticRenderFns } from "./TourIndex.vue?vue&type=template&id=a33a31b2&"
import script from "./TourIndex.vue?vue&type=script&lang=js&"
export * from "./TourIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports